import { render } from "./TotalOrders.vue?vue&type=template&id=91031c7e&scoped=true"
import script from "../js/total-orders.js?vue&type=script&lang=js&external"
export * from "../js/total-orders.js?vue&type=script&lang=js&external"

import "./TotalOrders.vue?vue&type=style&index=0&id=91031c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91031c7e"]])

export default __exports__